/**
 * Marker attribute for elements that must stay clickable while the onboarding
 * tour is active (e.g. the tour tooltip controls). Both the viewport-wide
 * {@link TourClickBlocker} and the `useOnClickOutside` guard consult this so a
 * tour click neither reaches the page underneath nor dismisses an open popup.
 */
export const TOUR_INTERACTIVE_SELECTOR = '[data-tour-interactive="true"]';

/**
 * True when `target` sits inside a tour-interactive element. Resolves text
 * nodes to their parent element before matching, since click/pointer targets
 * can be raw text nodes.
 */
export const isTourInteractiveTarget = (target: EventTarget | null) => {
  if (!(target instanceof Node)) return false;

  const element =
    target instanceof Element ? target : (target.parentElement ?? null);

  return Boolean(element?.closest(TOUR_INTERACTIVE_SELECTOR));
};
